<template>
  <div>
    <el-dialog :visible.sync="dialogCodeVisible" top="2%" @close="handleClose">
      <span slot="title">{{ title }}</span>
      <div class="confirmPay-content" v-loading="loading">
        <div class="confirmPay-search-box">
          <el-input
            v-model="searchText"
            placeholder="请输入或扫描药品追溯码"
            size="mini"
            style="width: 50%; margin-right: 10px"
            @keyup.enter.native="
              isMedicinePaidStatus !== 1 ? handleSearch() : handleQuery()
            "
          />
          <el-button
            size="mini"
            type="primary"
            v-if="isMedicinePaidStatus !== 1"
            @click="handleSearch"
            >保存</el-button
          >
          <el-button
            size="mini"
            type="primary"
            v-if="isMedicinePaidStatus === 1"
            @click="handleQuery"
            >查询</el-button
          >
          <el-button plain size="mini" @click="handleReset">重置</el-button>
        </div>
        <div class="confirmPay-title">追溯码列表</div>
        <div class="confirmPay-list" ref="traceListRef">
          <div
            class="confirmPay-item"
            v-for="item in traceList"
            :key="item.code"
          >
            <div class="confirmPay-item-content">
              <span class="confirmPay-item-code">{{ item.code }}</span>
              <span
                v-if="isMedicinePaidStatus !== 1"
                :class="['confirmPay-item-status', { red: item.status === 0 }]"
                >{{ item.status === 0 ? "验证未通过" : "验证通过" }}</span
              >
            </div>
            <i
              v-if="isMedicinePaidStatus !== 1"
              class="el-icon-delete confirmPay-item-delete"
              @click="handleDelete(item)"
            ></i>
          </div>
        </div>
      </div>
      <div class="confirmPay-button" v-if="isMedicinePaidStatus !== 1">
        <el-button plain size="mini" @click="dialogCodeVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="mini"
          :disabled="buttonDisabled"
          @click="handleSubmit"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ConfirmPay",
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      dialogCodeVisible: false,
      searchText: "",
      traceList: [],
      prescriptionId: "",
      title: "确认付药",
      isMedicinePaidStatus: 0,
    };
  },
  computed: {
    buttonDisabled() {
      if (this.traceList.length === 0) return true;
      const hasError = this.traceList.some((item) => item.status === 0);
      return hasError;
    },
  },
  methods: {
    async handleQuery() {
      this.loading = true;
      const { data } = await this.$api.prescription.GetPrescriptionBarcodes({
        prescriptionId: this.prescriptionId,
        keywords: this.searchText,
      });
      this.loading = false;
      this.traceList = [];
      data.forEach((item) => {
        this.traceList.push({
          code: item,
          status: 0,
        });
      });
    },
    handleDelete(item) {
      this.traceList = this.traceList.filter((i) => i.code !== item.code);
    },
    handleReset() {
      this.searchText = "";
    },
    async handleSearch() {
      if (!this.searchText) {
        this.$message.error("请输入追溯码");
        return;
      }
      if (this.traceList.some((item) => item.code === this.searchText)) {
        this.$message.error("追溯码已存在");
        return;
      }
      this.loading = true;
      const { data } = await this.$api.prescription.VerifyBarcode({
        barcodeNo: this.searchText,
      });
      this.loading = false;
      if (data) {
        this.traceList.push({ code: this.searchText, status: 1 });
      } else {
        this.traceList.push({ code: this.searchText, status: 0 });
      }
      this.$nextTick(() => {
        const el = this.$refs.traceListRef;
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },
    async handleSubmit() {
      this.loading = true;
      await this.$api.prescription.AddPrescriptionBarcodes({
        prescriptionId: this.prescriptionId,
        barcodes: this.traceList.map((item) => item.code),
      });
      this.loading = false;
      this.$message.success("确认付药成功");
      this.dialogCodeVisible = false;
      this.$emit("refresh");
    },
    handleClose() {
      this.traceList = [];
      this.prescriptionId = "";
      this.searchText = "";
    },
    async show(row) {
      this.prescriptionId = row.id;
      this.dialogCodeVisible = true;
      this.title = row.isMedicinePaidStatus === 1 ? "追溯码列表" : "确认付药";
      this.isMedicinePaidStatus = row.isMedicinePaidStatus;
      if (this.isMedicinePaidStatus === 1) {
        this.handleQuery();
      }
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
</style>
<style lang="scss" scoped>
@import "./confirmPay.scss";
</style>
